import { useI18n } from "@/lib/i18n";
import { Outlet } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import { I18nProvider } from "@/lib/i18n";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const LangDocEffects = () => {
  const { t, lang } = useI18n();
  useEffect(() => {
    document.documentElement.lang = lang === "en" ? "en" : "es";
    document.title = t("meta.title");
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", t("meta.description"));
  }, [lang, t]);
  return null;
};

const LangLayout = () => {
  const { lang } = useParams();
  const normalized = lang === "en" ? "en" : "ec";

  return (
    <I18nProvider>
      <LangDocEffects />
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </I18nProvider>
  );
};

export default LangLayout;
